(function () {
  if (window.__tvSeals) return;
  window.__tvSeals = true;

  var dialog = null;
  function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'bb-seal-pop';
    dialog.setAttribute('aria-labelledby', 'bb-seal-pop-title');
    dialog.innerHTML = '<button type="button" class="bb-seal-pop__close" aria-label="Close">&times;</button><div class="bb-seal-pop__card"></div>';
    dialog.querySelector('.bb-seal-pop__close').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.closest('a')) dialog.close(); });
    (document.querySelector('.tv-pdp') || document.body).appendChild(dialog);
    return dialog;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-seal-open]');
    if (!btn) return;
    var tpl = document.getElementById(btn.getAttribute('data-seal-open'));
    if (!tpl) return;
    var d = getDialog();
    var card = d.querySelector('.bb-seal-pop__card');
    card.replaceChildren(tpl.content.cloneNode(true));
    var title = card.querySelector('.bb-seal-pop__title');
    if (title) title.id = 'bb-seal-pop-title';
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  });
})();
